(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // SET THE SECOND LETTER OF THE TARGET WORD IN ITALIC
    const setFirstWordInItalic = (element, target = 1) => {
      const words = element.textContent
        .trim()
        .split(/\s+/)
        .filter((elem) => elem);
      const firstWord = words[0];
      const lastIndex = element.textContent.lastIndexOf(firstWord);

      const apostrophe = firstWord.indexOf("'");
      const hyphen = firstWord.indexOf("-");
      const isLastCharacter = (el, letter) => letter === el.length - 1;

      const otherWord = element.textContent.slice(0, lastIndex);
      let firstWordNew = "";

      if (firstWord === undefined) {
        return null;
      }

      if (firstWord.length >= target + 1) {
        if (apostrophe !== -1 && !isLastCharacter(firstWord, apostrophe)) {
          // For words containing apostrophe
          firstWordNew =
            element.textContent.slice(lastIndex, lastIndex + apostrophe + 1) +
            "<i>" +
            element.textContent.slice(lastIndex + apostrophe + 1, lastIndex + apostrophe + 2) +
            "</i>" +
            element.textContent.slice(lastIndex + apostrophe + 2);
        } else if (hyphen !== -1 && !isLastCharacter(firstWord, hyphen)) {
          // For words containing dash
          firstWordNew =
            element.textContent.slice(lastIndex, lastIndex + hyphen + 1) +
            "<i>" +
            element.textContent.slice(lastIndex + hyphen + 1, lastIndex + hyphen + 2) +
            "</i>" +
            element.textContent.slice(lastIndex + hyphen + 2);
        } else {
          // For regular words
          firstWordNew =
            element.textContent.slice(lastIndex, lastIndex + 1) +
            "<i>" +
            element.textContent.slice(lastIndex + 1, lastIndex + 2) +
            "</i>" +
            element.textContent.slice(lastIndex + 2);
        }
        // compile words
        element.innerHTML = otherWord + firstWordNew.toUpperCase();
      }
    };

    const italicWords = document.querySelectorAll(".ux-italicSecondLetter");

    italicWords.forEach((element) => {
      setFirstWordInItalic(element);
      // setfirstWordInItalic(element, 2);
    });
  });
})();
